export default "__VITE_ASSET__73de5878__"